import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arcAxis",
  "use": "icon-arcAxis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arcAxis\"><path d=\"M704 410.88a5.76 5.76 0 000 4.48 10.24 10.24 0 008.96 10.88l136.32 15.36h6.4a10.88 10.88 0 003.84-14.08l-70.4-117.76h-3.2a10.24 10.24 0 00-14.08 0l-19.2 28.8A448 448 0 00179.84 416l39.04 32a394.24 394.24 0 01504.96-64zm14.72 344.32h156.16V652.8h-56.32a312.96 312.96 0 00-615.68 0h-55.04v102.4H304V704a208 208 0 01416 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol